<template>
<!-- 这是学生家长请假的页面 -->
    <div class="people">
        <div class="box">
            <div class="content">
                <div class="div">
                    <div class="div1">{{fif}}</div>
                    <div class="div2">{{currentInfo.name}}</div>
                </div>
                <van-checkbox v-model="checked" icon-size="30px" checked-color="#00B893" @click="xuanzhong"></van-checkbox>
            </div>
        </div>
        <div class="bottom">
            <div class="bottom-box">
                <div>已选择{{date.length}}人</div>
                <van-button type="primary" style="background-color: #FFA900;border:0px" @click="confirm">确认({{date.length}}/1)</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Checkbox, CheckboxGroup,Button,Toast } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Toast);
export default {
    data(){
        return{
            currentInfo:JSON.parse(window.sessionStorage.getItem("currentInfo")),
            checked:false,//复选框
            date:[],//选中的人数
        }
    },
    methods:{
        xuanzhong(){
            console.log(this.checked)
            if(this.checked === true){
                this.date.push(this.currentInfo)
            }else{
                this.date = []
            }
        },
        confirm(){
            if(this.date.length === 1){
                window.sessionStorage.setItem("date",JSON.stringify(this.date))
                this.$router.push("/addLeaveStudent")
            }else{
                Toast.fail('请选择请假人');
            }
        }
    },
    mounted(){
        console.log(this.currentInfo)
    },
    computed:{
        fif(){
            return this.currentInfo.name.slice(0,1)
        }
    }
}
</script>

<style scoped>
    .people{
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #fff;
    }
    .box{
        width: calc(100% - 2rem);
        margin: 0 auto;
        background-color: #fff;
    }
    .content{
        width: 100%;
        height: 5.16rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .div{
        height: 4rem;
        width: 90%;
        display: flex;
        align-items: center;
    }
    .div1{
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        background-color: #00B893;
        font-size: 1.5rem;
        color: #fff;
        text-align: center;
        line-height: 3rem;
        margin-left: 1rem;
    }
    .div2{
        height: 4rem;
        line-height: 4rem;
        font-size: 1.5rem;
        margin-left: 1rem;
    }
    .bottom{
        height: 4rem;
        box-sizing: border-box;
        border-top: 1px solid #ccc;
        position: fixed;
        bottom: 0rem;
        width: 100%;
        background-color: #fff;
    }
    .bottom-box{
        height: 100%;
        width: calc(100% - 2rem);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bottom-box div{
        height: 100%;
        line-height: 4rem;
        font-size: 1rem;
    }
</style>